// extracted by mini-css-extract-plugin
export var _smallItem = "TemplateSingleItemIcon-module--_smallItem--3dabc";
export var aquamarine = "TemplateSingleItemIcon-module--aquamarine--c1fe0";
export var black = "TemplateSingleItemIcon-module--black--275e6";
export var blue = "TemplateSingleItemIcon-module--blue--5c94c";
export var carrot = "TemplateSingleItemIcon-module--carrot--da41d";
export var customColor = "TemplateSingleItemIcon-module--customColor--aab04";
export var customIcon = "TemplateSingleItemIcon-module--customIcon--1081f";
export var darkBlue = "TemplateSingleItemIcon-module--darkBlue--cca4c";
export var darkGray = "TemplateSingleItemIcon-module--darkGray--12318";
export var gray = "TemplateSingleItemIcon-module--gray--dabf4";
export var green = "TemplateSingleItemIcon-module--green--08350";
export var lightBlue = "TemplateSingleItemIcon-module--lightBlue--2c895";
export var lightColor = "TemplateSingleItemIcon-module--lightColor--aae51";
export var lightGreen = "TemplateSingleItemIcon-module--lightGreen--bc5e7";
export var magenta = "TemplateSingleItemIcon-module--magenta--669ba";
export var onlyIcon = "TemplateSingleItemIcon-module--onlyIcon--e3b9d";
export var onlyIconFix = "TemplateSingleItemIcon-module--onlyIconFix--7da4b";
export var pine = "TemplateSingleItemIcon-module--pine--9f3ed";
export var plum = "TemplateSingleItemIcon-module--plum--9db27";
export var templateInnerFix = "TemplateSingleItemIcon-module--templateInnerFix--421d0";
export var templateItemSquare = "TemplateSingleItemIcon-module--templateItemSquare--262b3";
export var templateItemSquareIcon = "TemplateSingleItemIcon-module--templateItemSquareIcon--c5946";
export var violet = "TemplateSingleItemIcon-module--violet--4b0e0";
export var white = "TemplateSingleItemIcon-module--white--368b7";
export var yellow = "TemplateSingleItemIcon-module--yellow--b33b2";